import React from 'react';

const SatPopOver = props => {
  const { visible, setVisible, overMenus = [] } = props;
  return (
    <div className="more-wrap">
      <button
        className={`ico ico-more ${visible ? 'active' : ''}`}
        onClick={() => setVisible(true)}
      />

      {visible && (
        <>
          <div className="more-view" onClick={e => e.stopPropagation()}>
            {overMenus.map((menus, menuIndex) => {
              return (
                <ul key={menuIndex}>
                  {menus.map((item, index) => {
                    return (
                      <li key={index}>
                        <span
                          onClick={() => {
                            item.handleClick();
                            setVisible(false);
                          }}
                        >
                          {item.label}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              );
            })}
          </div>

          <div
            className="dim-transparent"
            style={{ display: 'block' }}
            onClick={() => setVisible(false)}
          />
        </>
      )}
    </div>
  );
};

export default SatPopOver;
